import { render, staticRenderFns } from "./request-year.component.vue?vue&type=template&id=0096ec70&"
import script from "./request-year.component.vue?vue&type=script&lang=js&"
export * from "./request-year.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports